import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  CatalogTable,
  CatalogTableColumnsFunc,
} from '@backstage/plugin-catalog';
import catalogPlugin, { CatalogIndexPage } from '@backstage/plugin-catalog/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import newRelicPlugin from '@backstage-community/plugin-newrelic/alpha';

/**
 * Adds a "Type" column to Domain listings; every other kind keeps the
 * Backstage default columns.
 */
export const customCatalogColumns: CatalogTableColumnsFunc =
  entityListContext => {
    const defaults = CatalogTable.defaultColumnsFunc(entityListContext);
    if (entityListContext.filters.kind?.value === 'domain') {
      defaults.splice(1, 0, CatalogTable.columns.createSpecTypeColumn());
    }
    return defaults;
  };

// Without a `filters` prop the page renders the same default filter set as
// the former legacy index page; pagination stays off as it was.
const catalogIndexModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      params: {
        loader: async () => (
          <CatalogIndexPage
            columns={customCatalogColumns}
            initiallySelectedFilter="all"
          />
        ),
      },
    }),
  ],
});

// The home layout input is internal to the home plugin, so the layout must be
// installed by a module for `home`.
const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    homePlugin.getExtension('page:home').override({ params: { path: '/' } }),
    HomePageLayoutBlueprint.make({
      name: 'portal',
      params: {
        loader: () =>
          import('../components/home/HomePage').then(
            m => () => <m.HomePage />,
          ),
      },
    }),
  ],
});

// Custom layout with hard-coded Kind/Lifecycle filters; it renders its own
// page header, as before.
const searchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    searchPlugin.getExtension('page:search').override({
      params: {
        noHeader: true,
        loader: () =>
          import('../components/search/SearchPage').then(m => <m.SearchPage />),
      },
    }),
  ],
});

const newRelicModule = createFrontendModule({
  pluginId: 'newrelic',
  extensions: [
    newRelicPlugin
      .getExtension('page:newrelic')
      .override({ params: { path: '/newrelic' } }),
  ],
});

export const pageModules = [
  catalogIndexModule,
  homeModule,
  searchModule,
  newRelicModule,
];
